import { createFileRoute } from "@tanstack/react-router";
import PartsCatalog from "@/pages/PartsCatalog";
import PartsCatalogTest from "@/pages/PartsCatalogTest";
import { pageHead } from "@/lib/routeHead";
import { useThemeLayout } from "@/hooks/useThemeLayout";

// The parts catalog landing page is theme-aware: the CarMax theme shows the
// new storefront (formerly the /parts-preview test page); the Classic theme
// keeps its original catalog page unchanged.
export const Route = createFileRoute("/parts-catalog/")({
  head: () =>
    pageHead({
      title: "RV Parts & Accessories — Rex & Sons RV",
      description:
        "Shop thousands of RV parts and accessories at Rex & Sons RV. Search by part number, browse featured categories and trusted brands, or request a part from our team.",
      path: "/parts-catalog",
    }),
  component: PartsCatalogIndex,
});

function PartsCatalogIndex() {
  const layout = useThemeLayout();
  return layout === "carmax" ? <PartsCatalogTest /> : <PartsCatalog />;
}
